export const lang = {
  header: {
    sy: 'Home',
    cpjjfa: 'ProductsandSolutions',
    itfw: 'IT service',
    hzhb: 'Business coopt',
    gyhq: 'About Us'
  },
  // 首页
  HellowWorld: {

  },
  // 产品与解决方案
  ProductSolutions: {
    index: {
      cpyjjfa: '产品与解决方案',
      xydzf: '新一代支付',
      dsjfx: '大数据分析',
      hlwjr: '互联网金融',
      yhhyjjfa: '银行行业解决方案'
    }
  },
  ITservice: {
    index: {
      fw: 'IT service',
      jsfw: 'IT 技术服务',
      yyzcfw: 'IT 运营支撑服务'
    }
  },
  // 合作伙伴
  CooperativeTranslation: {

  },
  // 关于泓齐
  AboutUs: {

  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js